var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { class: [_vm.$style.card, _vm.factorClassNames[_vm.className]] },
    [
      _vm.showCustomLogo ? _c("LoginLogo") : _vm._e(),
      _vm._v(" "),
      _vm.header
        ? _c("h1", { class: _vm.$style.header }, [
            _vm._v("\n    " + _vm._s(_vm.header) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }